<template>
	<div class="nav-link-wrapper device-list">
		<router-link v-if="selectedAccount" class="nav-link" :to="{ name: 'UserWatchesDevices', params: { user_uid: selectedAccount } }">
			<svgicon name="watch" :fill="false"></svgicon>
			<span>{{ $t('base.general.devices') }}</span>
		</router-link>
	</div>
</template>

<script>
export default {
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationDevices.vue